import { gql, useLazyQuery } from "@apollo/client";
import { GoodStatus, ListCorporationSelectQuery } from "../gql/graphql";
import { CouponStatus, UserCouponStatus } from "../constants/props";

const LIST_CORPORATION_BY_LOCATION = gql`
  query listCorporationByLocation($input: ListCorporationByLocationInput!) {
    listCorporationByLocation(input: $input) {
      ok
      err
      mainCategories {
        id
        name
        imageUrl
        upload {
          url
          uuid
        }
      }
      corporations {
        id
        name
        address
        isActive
        coupons {
          id
          name
          status
          discountPrice
          validFrom
          validUntil
          userCoupons {
            id
            status
          }
        }
        mainCategories {
          id
          name
          imageUrl
          upload {
            url
            uuid
          }
        }
        goods {
          id
          title
          summary
          price
          discountRate
          status
          goodPosters {
            id
            upload {
              url
            }
          }
          goodReviews {
            id
            note
            rating
          }
        }
      }
    }
  }
`;

export interface ListCorporationByLocationQuery {
  listCorporationByLocation: {
    ok: boolean;
    err: string;
    corporations: {
      id: string;
      name: string;
      address: string;
      isActive: boolean;
      coupons: {
        id: number;
        name: string;
        status: CouponStatus;
        discountPrice: number;
        validFrom: string;
        validUntil: string;
        userCoupons?: {
          id: number;
          status: UserCouponStatus;
        }[];
      }[];
      mainCategories: {
        id: string;
        name: string;
        imageUrl: string;
      }[];
      goods: {
        id: string;
        title: string;
        summary: string;
        price: number;
        discountRate: number;
        status: GoodStatus;
        goodPosters: {
          id: string;
          upload: {
            url: string;
          };
        }[];
        goodReviews: {
          id: string;
          rating: number;
          note: string;
        }[];
      }[];
    }[];
    mainCategories: {
      id: string;
      name: string;
      imageUrl: string;
      upload: {
        url: string;
        uuid: string;
      };
    }[];
  };
}

export const useListCorporationByLocation = (
  onCompleted?: (data: ListCorporationByLocationQuery) => void
) => {
  return useLazyQuery<ListCorporationByLocationQuery>(
    LIST_CORPORATION_BY_LOCATION,
    {
      onCompleted,
      fetchPolicy: "network-only",
    }
  );
};
